import { getSessionUUID } from '../components/lib/AuthToken';
import logger from '../utils/logger';

export const fetchDeliveryDetailsByDate = async (date) => {
    try {
        const sessionToken = await getSessionUUID();
        const response = await fetch(`/delivery_details/by_date?date=${encodeURIComponent(date)}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`,
            },
        });
        const data = await response.json();
        return { status: response.status, data };
    } catch (err) {
        logger.error('Error fetching delivery alerts by date:', err);
        return { status: 500, data: [] };
    }
};

export const fetchDeliveryDetailsByRouteRef = async (route_ref) => {
    try {
        const sessionToken = await getSessionUUID();
        const response = await fetch(`/delivery_details/by_route_ref?route_ref=${encodeURIComponent(route_ref)}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`,
            },
        });
        const data = await response.json();
        return { status: response.status, data };
    } catch (err) {
        logger.error('Error fetching delivery details:', err);
        return { status: 500, data: null };
    }
};

export const createDeliveryDetails = async (payload) => {
    try {
        const sessionToken = await getSessionUUID();
        const response = await fetch('/delivery_details/', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`,
            },
            body: JSON.stringify(payload),
        });
        const data = await response.json();
        return { status: response.status, data };
    } catch (err) {
        logger.error('Error creating delivery details:', err);
        return { status: 500, data: null };
    }
};

export const updateDeliveryDetails = async (id, payload) => {
    try {
        const sessionToken = await getSessionUUID();
        const response = await fetch(`/delivery_details/${id}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`,
            },
            body: JSON.stringify(payload),
        });
        const data = await response.json();
        return { status: response.status, data };
    } catch (err) {
        logger.error('Error updating delivery details:', err);
        return { status: 500, data: null };
    }
};
